import React from 'react';

interface ICamperIconProps {
	size?: string;
	className?: string;
}

export const CamperIcon = ({ size = '24', className }: ICamperIconProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
			<path
				d="M17.925 18.3002C18.3552 18.3002 18.7757 18.1726 19.1334 17.9336C19.491 17.6947 19.7698 17.355 19.9344 16.9575C20.0991 16.5601 20.1421 16.1228 20.0582 15.7009C19.9743 15.279 19.7671 14.8914 19.463 14.5872C19.1588 14.2831 18.7712 14.0759 18.3493 13.992C17.9274 13.9081 17.4901 13.9511 17.0927 14.1158C16.6952 14.2804 16.3555 14.5592 16.1166 14.9168C15.8776 15.2745 15.75 15.695 15.75 16.1252C15.75 16.702 15.9792 17.2553 16.387 17.6632C16.7949 18.071 17.3482 18.3002 17.925 18.3002V18.3002Z"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path
				d="M4.925 18.3002C5.35517 18.3002 5.77569 18.1726 6.13337 17.9336C6.49104 17.6947 6.76982 17.355 6.93444 16.9575C7.09906 16.5601 7.14213 16.1228 7.05821 15.7009C6.97429 15.279 6.76714 14.8914 6.46296 14.5872C6.15878 14.2831 5.77123 14.0759 5.34932 13.992C4.92741 13.9081 4.49009 13.9511 4.09266 14.1158C3.69523 14.2804 3.35555 14.5592 3.11655 14.9168C2.87756 15.2745 2.75 15.695 2.75 16.1252C2.75 16.702 2.97915 17.2553 3.38704 17.6632C3.79493 18.071 4.34815 18.3002 4.925 18.3002V18.3002Z"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path d="M14.9998 16.5752H7.4248" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
			<path
				d="M2.2498 16.5752C1.86392 16.5964 1.48475 16.4678 1.19132 16.2163C0.897899 15.9648 0.712869 15.6098 0.674805 15.2252V7.4252C0.694166 6.96092 0.892322 6.52213 1.22781 6.20062C1.5633 5.8791 2.01013 5.69979 2.4748 5.7002H17.9248C18.9748 5.7002 20.0998 7.6502 21.4498 9.1502C22.7998 10.6502 23.1748 10.1252 23.1748 12.3752V14.7002C23.1748 15.4502 22.6498 16.5752 21.5998 16.5752H20.3248"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path
				d="M17.9248 5.94678V9.15026C17.9248 9.40885 18.0275 9.65684 18.2104 9.83969C18.3932 10.0225 18.6412 10.1253 18.8998 10.1253H22.1248"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path d="M22.5 12.375H21.75" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
			<path d="M10.4248 12.4502H9.6748" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
		</svg>
	);
};
